/**
 * UI event handlers for buttons and controls.
 * @module ui/handlers
 */

import { requestCancel } from "../state";
import { setStatus, progress } from "./status";
import { OPTIONS_STORAGE_KEY, EMAIL_STORAGE_KEY } from "../config";

/**
 * Clears the saved email and focuses the input field.
 */
export function changeEmail() {
  localStorage.removeItem(EMAIL_STORAGE_KEY);
  document.getElementById("email-input").value = "";
  document.getElementById("email-input").focus();
  setStatus("", "");
}

/**
 * Toggles the user guide panel visibility.
 */
export function openGuide() {
  const panel = document.getElementById("guide-panel");
  const btn = document.getElementById("guide-btn");
  const visible = panel.style.display === "block";
  panel.style.display = visible ? "none" : "block";
  btn.textContent = visible ? "Guide utilisateur" : "Masquer le guide";
}

/**
 * Shows/hides SBI metadata fields when header or cover page checkboxes change.
 * Saves the option states to localStorage.
 */
export function toggleSbiMetaFields() {
  const headerChecked = document.getElementById("sbi-header-check").checked;
  const coverChecked = document.getElementById("sbi-cover-check").checked;
  document.getElementById("sbi-header-fields").style.display = (headerChecked || coverChecked) ? "block" : "none";
  saveOptions();
}

/**
 * Requests cancellation and cleans up the visual feedback immediately.
 * The insert button stays disabled until the background operation finishes
 * (via the finally block in insertPage) to prevent concurrent imports.
 */
export function cancelImport() {
  requestCancel();
  // Clean visual feedback — no "Annulation en cours..." phase
  document.getElementById("cancel-btn").style.display = "none";
  progress.hide();
  setStatus("", "");
  // insert-btn stays disabled — re-enabled by insertPage() finally block
}

// ── Options persistence ─────────────────────────────

const OPTIONS_KEY = OPTIONS_STORAGE_KEY;

const OPTION_IDS = [
  "toc-check",
  "divider-pagebreak-check",
  "sbi-cover-check",
  "sbi-header-check",
];

/**
 * Saves checkbox and select states to localStorage.
 */
export function saveOptions() {
  const state = {};
  for (const id of OPTION_IDS) {
    const el = document.getElementById(id);
    if (el) state[id] = el.checked;
  }
  const select = document.getElementById("heading-pagebreak-select");
  if (select) state["heading-pagebreak-select"] = select.value;
  localStorage.setItem(OPTIONS_KEY, JSON.stringify(state));
}

/**
 * Restores checkbox and select states from localStorage.
 */
export function restoreOptions() {
  try {
    const raw = localStorage.getItem(OPTIONS_KEY);
    if (!raw) return;
    const state = JSON.parse(raw);
    for (const id of OPTION_IDS) {
      const el = document.getElementById(id);
      if (el && typeof state[id] === "boolean") el.checked = state[id];
    }
    const select = document.getElementById("heading-pagebreak-select");
    if (select && state["heading-pagebreak-select"]) {
      select.value = state["heading-pagebreak-select"];
    }
    // Sync SBI fields visibility
    toggleSbiMetaFields();
  } catch (_) {
    /* localStorage corrompu, on ignore */
  }
}
